import { useEffect } from "react";
import AddCommentForm from "./AddCommentForm/AddCommentForm";
import CommentItem from "./CommentItem/CommentItem";
import { CommentContext } from "./context/CommentContext";
import useCommentList from "./useCommentList";
import "./commentList.scss";

// Liste des commentaires d'une fiche, dans l'ordre reçu, puis la saisie d'un
// nouveau commentaire. Les actions (ajouter, modifier, supprimer) sont celles
// de la page qui l'affiche.
const CommentList = ({ initComments, onUpdateComments, onUpdateComment, onAddComment, onDeleteComment, users }) => {
  const { comments, setupComments, actions } = useCommentList(onUpdateComments, onUpdateComment, onAddComment, onDeleteComment);

  useEffect(() => {
    setupComments(initComments, users);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initComments]);

  return (
    <div className="cl">
      {comments.length > 0 ? (
        <ol className="cl-liste">
          {comments.map((comment) => (
            <li key={`compcom${comment.id}`} className="cl-com">
              <CommentContext.Provider value={{ comment, actions }}>
                <CommentItem users={users} />
              </CommentContext.Provider>
            </li>
          ))}
        </ol>
      ) : (
        <p className="cl-vide">Aucun commentaire.</p>
      )}
      <div className="cl-composer">
        <AddCommentForm addComment={actions.addComment} users={users} />
      </div>
    </div>
  );
};

export default CommentList;
